import { USER_DASHBOARD_PAGE_KEY } from '../constants';
import { routesLocalesEs } from '../routes/i18n';
import { savedCoursesEs } from '../routes/SavedCourses/i18n';
import { EXTERNAL_LOCALES_ES } from './externals';

const es = {
  [USER_DASHBOARD_PAGE_KEY]: {
    ...routesLocalesEs,
    ...savedCoursesEs,
    // Titles
    UD_ENROLLMENTS_TITLE: 'Mis cursos',
    UD_ENROLLMENTS_COURSES: 'Todos mis cursos',
    UD_ENROLLMENTS_TRACKS: 'Mis especializaciones',
    UD_ENROLLMENTS_CAREERS: 'Mis carreras',
    UD_ENROLLMENTS_BUNDLES: 'Mis certificaciones',
    UD_ENROLLMENTS_DEGREES: 'MicroDegree',
    UD_ENROLLMENTS_ACADEMIES: 'Academias',
    UD_ENROLLMENTS_NEW_TAG: 'Nuevo',
    UD_ENROLLMENTS_BOOTCAMPS: 'Bootcamp',
    UD_CLASSNOTES_TITLE: 'Mis apuntes',
    UD_PROJECTS_TITLE: 'Mis proyectos',
    UD_DIPLOMAS_TITLE: 'Mis diplomas',
    UD_STUDY_PLAN_TITLE: 'Mi plan de estudios',
    // Onboarding
    UD_ONBOARDING_WELCOME_TITLE:
      '¡Te damos la bienvenida a tu nuevo panel de estudiante!',
    UD_ONBOARDING_WELCOME_DESC:
      'Te contamos las nuevas mejoras que tenemos para ti.',
    UD_ONBOARDING_MOBILE_MENU_TITLE: 'Nueva barra de menú',
    UD_ONBOARDING_MOBILE_MENU_DESC:
      'Implementamos una nueva barra de menú para que tengas una mejor navegación entre las secciones de Mis cursos, Mis apuntes, Mis proyectos, Mis diplomas y Mi plan de estudios.',
    UD_ONBOARDING_ENROLLMENTS_TITLE: 'Mis cursos',
    UD_ONBOARDING_ENROLLMENTS_DESC:
      'Aquí no solo encontrarás todos los cursos inscritos, sino tambien el progreso de tus especializaciones.',
    UD_ONBOARDING_CLASSNOTES_TITLE: 'Mis apuntes',
    UD_ONBOARDING_CLASSNOTES_DESC:
      'Todos los apuntes que tomes dentro de todos tus cursos los podrás revisar aquí.',
    UD_ONBOARDING_PROJECTS_TITLE: 'Mis proyectos',
    UD_ONBOARDING_PROJECTS_DESC:
      'Encuentra en esta sección todos los proyectos que estés trabajando. Tambien podrás visualizar el estado de revisión de cada uno, incluso los que ya están certificados.',
    UD_ONBOARDING_DIPLOMAS_TITLE: 'Mis diplomas',
    UD_ONBOARDING_DIPLOMAS_DESC:
      'Ubica aquí tus diplomas Crehana, una vez que ya haya sido aprobado tu proyecto final.',
    UD_ONBOARDING_STUDY_PLAN_TITLE: 'Mi plan de estudios',
    UD_ONBOARDING_STUDY_PLAN_DESC:
      '¿Sabías que las personas más exitosas generan hábitos? En esta sección te ayudamos a cumplir tus metas.',
    UD_ONBOARDING_NIGHT_SWITCH_TITLE: 'Únete al lado oscuro',
    UD_ONBOARDING_NIGHT_SWITCH_DESC:
      'Personaliza tu panel al modo nocturo activando este switch.',
    UD_ONBOARDING_CONFIG_TITLE: 'Ajustes dentro de tu cuenta',
    UD_ONBOARDING_CONFIG_DESC:
      'Ten un acceso más directo a toda la configuración de tu cuenta en este enlace.',
    UD_ONBOARDING_FAQ_TITLE: 'Resolviendo tus preguntas',
    UD_ONBOARDING_FAQ_DESC:
      'Si aún tienes dudas sobre como funciona la plataforma, con mucho gusto te podemos ayudar dentro del Centro de Ayuda Crehana.',
    UD_ONBOARDING_SEARCH_TITLE: '¿Qué buscas en tu panel?',
    UD_ONBOARDING_SEARCH_DESC:
      'Ten una búsqueda más acertada de lo que necesitas de tu panel en esta sección.',
    // Filters & FAQ
    UD_FILTER_LABEL: 'Filtrar por',
    UD_SEARCH_HINT: 'Busca tus cursos, proyectos...',
    UD_SEARCH_PROJECT_SUBTITLE: 'Proyecto de {{course}}',
    UD_SEARCH_ERROR: 'Ocurrió un error al obtener la información de tu panel.',
    UD_SEARCH_NO_RESULTS: 'No encontramos resultados para tu búsqueda',
    UD_GO_TO_COURSES: 'Ver todos mis cursos',
    UD_CONFIGURATION: 'Configuración',
    UD_FAQ_COURSE: 'No encuentro mi curso',
    UD_FAQ_PROJECT_UPLOAD: 'Subida de proyectos',
    UD_FAQ_START_COURSES: '¿Cómo empiezo mis cursos?',
    UD_FAQ_DIPLOMA: '¿Cómo obtengo mi diploma?',
    UD_FAQ_ONBOARDING: '¿Cómo funciona mi panel?',
    UD_FAQ_GENERAL: '¿Aún con dudas? Entra a nuestro',
    UD_FAQ_GENERAL_LINK: 'Centro de Ayuda Crehana',
    // Enrollments components and actions
    UD_TRACK_TITLE: 'Especialización en {{title}}',
    UD_DURATION: 'Duración: {{duration}}',
    UD_DOWNLOAD_SYLLABUS: 'Descarga el sílabo',
    UD_DOWNLOAD_DIPLOMA: 'Descarga tu diploma',
    UD_START_COURSE: 'Empezar curso',
    UD_CONTINUE_COURSE: 'Continuar curso',
    UD_REWATCH_COURSE: 'Ver nuevamente',
    UD_CREATE_PROJECT: 'Iniciar proyecto',
    UD_EDIT_PROJECT: 'Editar proyecto',
    UD_GO_TO_PROJECT: 'Ver proyecto',
    UD_MODULE_LIST_PROGRESS: '{{completed}}/{{total}} módulos completados',
    UD_COURSE_LIST_PROGRESS: '{{completed}}/{{total}} cursos completados',
    UD_PROJECT_LIST_PROGRESS: '{{completed}}/{{total}} proyectos certificados',
    UD_SAVED_COURSES_TITLE: 'Mis guardados',
    UD_SAVED_COURSES_TOUR_TITLE: 'Guarda para ver después',
    UD_SAVED_COURSES_TITLE_DESC:
      'Ahora puedes guardar cursos. ¡No pierdas de vista tu aprendizaje!',
    // FAQ'S
    UD_UPLOAD_PROJECTS: '¿Cómo subo mis proyectos?',
    UD_START_COURSES: '¿Cómo empiezo mis cursos asignados?',
    UD_CHAT_WITH_MENTORS: '¿Cómo converso con los mentores?',
    UD_UPLOAD_PROJECT: '¿Cómo subo mi proyecto?',
    UD_CANT_FIND_COURSES: 'No encuentro mis cursos',
    UD_UPLOAD_PROJECTS_TO_PLATFORM: '¿Cómo subo mi proyecto a la plataforma?',
    UD_PROJECT_DESCRIPTION: '¿Dónde encuentro la descripción de mi proyecto?',
    ...EXTERNAL_LOCALES_ES,
  },
};
export default es;
